import {z} from "zod";

export enum WorkflowRepresentationType {
    V_CYCLE = 'V_CYCLE',
    GRID = 'GRID',
}

export const WorkflowRepresentationTypeSchema = z.enum(WorkflowRepresentationType);
